import DialogWrapper from "./Dialog";
import confirm from "./confirm";

export interface ModalFuncProps {
  prefixCls?: string;
  className?: string;
  visible?: boolean;
  title?: React.ReactNode;
  content?: React.ReactNode;

  onOk?: (...args: any[]) => any;
  onCancel?: (...args: any[]) => any;

  centered?: boolean;
  width?: string | number;
  okText?: React.ReactNode;

  cancelText?: React.ReactNode;
  icon?: React.ReactNode;
  mask?: boolean;
  maskClosable?: boolean;
  zIndex?: number;
  okCancel?: boolean;
  style?: React.CSSProperties;
  maskStyle?: React.CSSProperties;
  type?: string;
  keyboard?: boolean;

  autoFocusButton?: null | "ok" | "cancel";
  transitionName?: string;
  maskTransitionName?: string;
}

export type ModalFunc = (props: ModalFuncProps) => void;
export interface ModalStaticFunctions {
  info: ModalFunc;
  success: ModalFunc;
  error: ModalFunc;
  warn: ModalFunc;
  warning: ModalFunc;
  confirm: ModalFunc;
}

type Modal = typeof DialogWrapper & ModalStaticFunctions;

const Modal = DialogWrapper as Modal;

Modal.info = function infoFn(props) {
  return confirm({
    ...props,
    width: 300,
    okCancel: false,
  });
};

export const destroyFns: Array<() => void> = [];

export default Modal;
